<template>
  <div class="careerReport">
    <div v-if="version == 1">
      <div class="main" v-if="reportId">
        <div>
          <div class="partTitle">人格特性</div>
          <Rgtx :reportId="reportId"></Rgtx>
        </div>
        <div>
          <div class="partTitle">智能水平</div>
          <Rzqn :reportId="reportId"></Rzqn>
        </div>
        <div>
          <div class="partTitle">兴趣倾向</div>
          <Xqqx :reportId="reportId"></Xqqx>
        </div>
        <div>
          <div class="partTitle">职业价值观</div>
          <Zysy :reportId="reportId"></Zysy>
        </div>
        <div>
          <div class="partTitle">心理适应性</div>
          <Xljk :reportId="reportId"></Xljk>
        </div>
      </div>
    </div>
    <div v-if="version == 2">
      <div class="main">
        <div>
          <div class="partTitle">人格特性</div>
          <Rgtx2 :mbti="mbti"></Rgtx2>
        </div>
        <div>
          <div class="partTitle">智能水平</div>
          <Znsp2 :intelligent="intelligent"></Znsp2>
        </div>
        <div>
          <div class="partTitle">兴趣倾向</div>
          <Xqqx2 :hobby="hobby" :radarChart="radarChart"></Xqqx2>
        </div>
        <div>
          <div class="partTitle">职业价值观</div>
          <Zyjzg2 :profession="profession"></Zyjzg2>
        </div>
        <div>
          <div class="partTitle">心理适应性</div>
          <Xlsyx2 :mind="mind" :result="result"></Xlsyx2>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Rgtx from "@/views/consultant/student/new/main/components/evalutionReport/rgtx";
import Rzqn from "@/views/consultant/student/new/main/components/evalutionReport/rzqn";
import Xqqx from "@/views/consultant/student/new/main/components/evalutionReport/xqqx";
import Zysy from "@/views/consultant/student/new/main/components/evalutionReport/zysy";
import Xljk from "@/views/consultant/student/new/main/components/evalutionReport/xljk";

//新
import Rgtx2 from "@/views/consultant/student/new/main/components/evalutionReport2/rgtx";
import Znsp2 from "@/views/consultant/student/new/main/components/evalutionReport2/znsp";
import Xqqx2 from "@/views/consultant/student/new/main/components/evalutionReport2/xqqx";
import Zyjzg2 from "@/views/consultant/student/new/main/components/evalutionReport2/zyjzg";
import Xlsyx2 from "@/views/consultant/student/new/main/components/evalutionReport2/xlsyx";

export default {
  name: "careerReport",
  props: ["userType", "componentId"],
  components: {
    Rgtx,
    Rzqn,
    Xqqx,
    Zysy,
    Xljk,
    Rgtx2,
    Znsp2,
    Xqqx2,
    Zyjzg2,
    Xlsyx2,
  },
  data() {
    return {
      studentId: sessionStorage.getItem("myStudentStudentId"), //学生id
      reportId: "",
      api: "",
      version: "",
      reportId: "",
      mbti: {},
      intelligent: [],
      hobby: {},
      radarChart: [],
      radarValue: [],
      profession: {}, //职业倾向
      mind: {},
      result: [],
      bgArr: [], //八卦
      bgNewArr: [
        "R-实际型",
        "C-传统型",
        "E-企业型",
        "S-社会型",
        "A-艺术型",
        "I-研究型",
      ],
      bgNewArr2: [],
    };
  },
  mounted() {
    //this.reportId='02b4998babda49d58a0a7bb7c3c6211a';
    //  this.getReportData(this.reportId)
        this.judgeNewOld();
  },
  methods: {
    judgeNewOld() {
        let studentId = this.studentId;
      this.$ajax
        .post(
          this.G_acapi + this.api,
          {
              studentId:studentId
            // studentId:this.$route.query.studentId||window.sessionStorage.getItem('myStudentStudentId')
          },
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then((res) => {
          if (res.data.code == 2000) {
            console.log(res);
              this.version=res.data.data.version;
              this.reportId=res.data.data.reportId;
            // this.version = 2;
            // this.reportId = "02b4998babda49d58a0a7bb7c3c6211a";
            if (this.version == 2) {
              this.getReportData(this.reportId);
            }
          } else {
          }
        });
    },
    getReportData(id) {
      this.$ajax
        .post(
          this.G_capi + this.ports.consultant.student.report.newReportData,
          {
            reportId: id,
          },
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then((res) => {
          if (res.data.code == 2000) {
            console.log(res);
            this.mbti = res.data.data.mbti; //人格特性
            this.intelligent = res.data.data.intelligent; //智能水平
            this.hobby = res.data.data.hobby; //兴趣倾向
            this.radarChart = res.data.data.hobby.radarChart;
            this.threeYard = res.data.data.hobby.threeYard;
            this.profession = res.data.data.profession; //职业价值观
            this.mind = res.data.data.mind; //心里适应性
            this.result = res.data.data.mind.result;
            for (var i = 0; i < this.radarChart.length; i++) {
              this.bgArr.push({
                name: this.radarChart[i].type + "-" + this.radarChart[i].name,
                value: this.radarChart[i].value,
                max: 20,
                type: this.radarChart[i].type,
              });
            }

            for (var i = 0; i < this.threeYard.length; i++) {
              for (var j = 0; j < this.bgArr.length; j++) {
                if (this.threeYard[i] == this.bgArr[j].type) {
                  this.bgArr[j].color = "#1CA4B6";
                  // this.bgArr[j].fontSize = "20"
                }
              }
            }

            for (var i = 0; i < this.bgNewArr.length; i++) {
              this.bgArr.forEach((item) => {
                if (this.bgNewArr[i] == item.name) {
                  this.bgNewArr2.push(item);
                }
              });
            }
            for (var i = 0; i < this.bgNewArr2.length; i++) {
              this.radarValue.push(this.bgNewArr2[i].value);
            }

            this.$nextTick(() => {
              //  this.drawBagua(this.bgNewArr2);
            });
          } else {
          }
        });
    },
    getReportId() {
      let studentId = this.studentId;
      this.$ajax
        .post(
          this.G_acapi + this.api,
          {
            studentId: studentId,
          },
          {
            headers: {
              token: window.sessionStorage.getItem("ymtxToken"),
            },
          }
        )
        .then((res) => {
          let data = res.data;
          if (data.code == 2000) {
            this.reportId = res.data.data.reportId;
          }
        });
    },
  },
  created() {
      console.log(this.userType)
    if (this.userType == 1) {
      this.api =
        this.ports.student.student.studentMessage.careerReport.getCareerReportIdByStudentIdByStudent;
    } else if (this.userType == 2) {
      this.api =
        this.ports.parent.student.studentMessage.careerReport.getCareerReportIdByStudentIdByParent;
    } else if (this.userType == 3) {
      this.api = this.ports.consultant.student.new.getReportId;
    }
    this.getReportId();

  },
};
</script>

<style scoped lang="less">
.careerReport {
  .main {
    background: #fff;
    .title {
      font-size: 32px;
      font-weight: bolder;
      line-height: 80px;
      text-align: center;
      color: #0094ea;
    }
    .partTitle {
      font-size: 20px;
      color: #0094ea;
      font-weight: bolder;
      padding: 30px 0;
    }
  }
}
</style>